import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";
import type { AuditLog } from "@/types/database";

export function useAuditLogs(actionFilter?: string) {
  const { activeOrgId } = useAuth();

  return useQuery({
    queryKey: ["audit_logs", activeOrgId, actionFilter],
    enabled: !!activeOrgId,
    queryFn: async () => {
      let query = supabase
        .from("audit_logs")
        .select("*")
        .eq("organization_id", activeOrgId!)
        .order("created_at", { ascending: false })
        .limit(100);

      if (actionFilter && actionFilter !== "all") {
        if (actionFilter === "booking") {
          query = query.ilike("action", "%booking%");
        } else if (actionFilter === "host") {
          query = query.ilike("action", "%host%");
        } else if (actionFilter === "fee") {
          query = query.or("action.ilike.%fee%,action.ilike.%financial%,action.ilike.%collected%");
        } else if (actionFilter === "config") {
          query = query.or("action.ilike.%config%,action.ilike.%bylaw%,action.ilike.%updated%");
        }
      }

      const { data, error } = await query;
      if (error) throw error;
      return data as AuditLog[];
    },
  });
}
